export class DnDTools {

    public static readonly IE11MimeType: string = 'text';

    public static getMimeType(typeName: string): string {
        const typeNameLower = typeName.toLowerCase();
        const mimeType = `application/json;parameter=${typeNameLower}`;
        return mimeType;
    }

    public static getMimeTypeForEdge(typeName: string): string {
        const typeNameLower = typeName.toLowerCase();
        const mimeType = `application/json-parameter-${typeNameLower}`;
        return mimeType;
    }

}
